<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink"
      :readonly="readonly" @focus="onFocus"  :required="required"  :rules="[{ required: required, message: label+'不可为空' }]"/>
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" name="abc" :title="title" class="action-sheet-box">
      <!-- 搜索区域 -->
      <van-search v-model="search" placeholder="请输入关键词" @input="OnInput"></van-search>
      <van-cell v-for="(item,index) in dataList.filter(obj=>obj.trueName.indexOf(search)!=-1)" :key="index"
        :title="item.trueName+' - '+item.cardNo+' - '+item.secName" :is-link="isLink" @click="onSelect(item)">
      </van-cell>
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    name: 'DepartmentSelect',
    props: {
      label: {
        type: String,
        default: '未定义'
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      title: {
        type: String,
        default: '请选择'
      },
      parentId: {
        type: String,
        default: ""
      },
      value: {
        default: ''
      },
      //是否存在科室过滤条件
      hasDepartmentGuid: {
        type: Boolean,
        default: true,
      },
      // 是否必填
      required: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        form: {
          token: ''
        },
        search: "",
        selectValue: this.value,
        isLink: true,
        readonly: true,
        show: false,
        dataList: [],
        token: '',
        companyid: ''
      }
    },
    watch: {
      value(newVal) {
        this.selectValue = newVal
      },
      parentId() {
        console.log("触发");
        this.initData()
      }
    },
    methods: {
      onFocus: function() {
        this.show = true
      },
      //搜索框变化事件
      OnInput: function() {
        this.initData()
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false
        this.selectValue = item.trueName
        this.$emit('input', this.selectValue)
        this.$emit('update:selectkey', item.guid)

        this.$emit("SetUserInfo",item)

      },
      initData: function() {
        let args = {
          currentPage: 1,
          trueName: this.search,
          pageSize: 200000,
		  menuid:this.$utils.MenuEnum.user
        }
        var that = this    
        that.$utils.HttpPost(that.$utils.Url.system + '/api/APISEMP_User/AllList', args, function(data) {
          
          if(that.parentId) {
			  that.dataList=[]
			  data.data.forEach((item) => {
			  	for (var key in item) {
			  		item[that.$utils.toLowerCaseFirst(key)] = item[key]
			  	}
			  	if (item.departmentGuid == that.parentId) {
			  		that.dataList.push(item)
			  	}
			  })
          }
          
          //如果不存在单位ID过滤条件，直接返回所有的科室列表
          if (!that.hasDepartmentGuid) {
            that.dataList = data.data
            return;
          }
          
        }, null, null)
      }
    },
    mounted: function() {
      this.initData()
    }
  }
</script>

<style>
</style>
